import {useEffect, useState} from "react";
import {preloadImages} from "../../helpers/images";
import {IMG_ASSETS} from "../assets/assets";


const Loader = () => {
  const [isHide, setIsHide] = useState(false)
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    //IMAGE LOADER MODULE
    preloadImages(
      IMG_ASSETS,
      (progress) => setProgress(progress),
      () => setIsHide(true)
    );
  }, []);

 if(isHide) return null
 return <div className="loader-bar">
    Loading assets: {Math.round(progress * 100)}%
   <button
     onClick={()=>setIsHide(true)}
    style={{
      position: 'absolute',
      top: 10,
      right: 10,
      color: "wheat",
    }}
   >
     [hide]
   </button>
    <progress value={progress} max="1"></progress>

  </div>
}

export default Loader